
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 121 163","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M60.5 129.32c26.41 0 47.82-21.41 47.82-47.82S86.91 33.68 60.5 33.68 12.68 55.09 12.68 81.5s21.41 47.82 47.82 47.82zm0 4.68c28.995 0 52.5-23.505 52.5-52.5S89.495 29 60.5 29 8 52.505 8 81.5 31.505 134 60.5 134z","fill":"#0E193F"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M39.5 94.32c7.08 0 12.82-5.739 12.82-12.82 0-7.08-5.74-12.82-12.82-12.82S26.68 74.42 26.68 81.5c0 7.081 5.74 12.82 12.82 12.82zm0 4.68C49.165 99 57 91.166 57 81.5S49.165 64 39.5 64 22 71.835 22 81.5 29.835 99 39.5 99zM81.5 94.32c7.08 0 12.82-5.739 12.82-12.82 0-7.08-5.74-12.82-12.82-12.82-7.081 0-12.82 5.74-12.82 12.82 0 7.081 5.739 12.82 12.82 12.82zm0 4.68C91.165 99 99 91.166 99 81.5S91.165 64 81.5 64 64 71.835 64 81.5 71.834 99 81.5 99z","fill":"#0E193F"}}),_c('path',{attrs:{"d":"M71 53.5C71 59.299 66.3 64 60.5 64 54.701 64 50 59.299 50 53.5S54.701 43 60.5 43C66.3 43 71 47.701 71 53.5z","fill":"#0E193F"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M60.5 59.32a5.82 5.82 0 100-11.64 5.82 5.82 0 000 11.64zm0 4.68C66.3 64 71 59.299 71 53.5S66.3 43 60.5 43C54.701 43 50 47.701 50 53.5S54.701 64 60.5 64z","fill":"#0E193F"}}),_c('path',{attrs:{"d":"M71 109.5c0 5.799-4.7 10.5-10.5 10.5-5.799 0-10.5-4.701-10.5-10.5S54.701 99 60.5 99C66.3 99 71 103.7 71 109.5z","fill":"#0E193F"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M60.5 115.32a5.82 5.82 0 100-11.64 5.82 5.82 0 000 11.64zm0 4.68c5.8 0 10.5-4.701 10.5-10.5S66.3 99 60.5 99C54.701 99 50 103.7 50 109.5S54.701 120 60.5 120z","fill":"#0E193F"}})])
          )
        }
      }
    